import { EcranMagasin, VendeurSilencieux, VideoWall } from 'pages/gant/constantes/medias';
import HotFolderModal from 'pages/hot/modals/HotFolderModal';
import GenericGrid from 'pages/tables/GenericGrid';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { useEffect } from 'react';
import 'scss/_tablePage.scss';
import { useRemoveDocumentMutation } from '../../../../redux/api/cache';

export default function Document(props) {
  const [data, setData] = useState(props.data.data);
  const [hotFolderModal, setHotFolderModal] = useState(false);
  const [removeDocument] = useRemoveDocumentMutation();

  useEffect(() => {
    setData(props.data.data);
  }, [props.data.data]);

  return (
    <Fragment>
      {hotFolderModal && (
        <HotFolderModal
          params={{
            ann_seq: props.rowData.ann_seq,
            camp_seq: props.rowData.camp_seq,
            media_cd: props.media,
            from: 'publicite',
          }}
          onSave={() => {
            setHotFolderModal(false);
          }}
          onClose={() => setHotFolderModal(false)}
          camp_num={props.rowData.camp_num}
        />
      )}

      <GenericGrid
        autoSize={true}
        rowClicked={() => { }}
        showCreateBtn={props.media === EcranMagasin || props.media === VendeurSilencieux || props.media === VideoWall}
        txtBtn="Ajouter un document"
        onCreateClick={() => setHotFolderModal(true)}
        definition={props.data.meta.definition}
        data={data}
        showDocumentsButtonsCell={true}
        removeFile={async (ridDocument) => {
          await removeDocument(ridDocument);
        }}
      />
    </Fragment>
  );
}

Document.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.array,
    meta: PropTypes.shape({
      definition: PropTypes.array,
    }),
  }),
  media: PropTypes.string,
  rowData: PropTypes.shape({
    ann_seq: PropTypes.any,
    camp_seq: PropTypes.any,
    camp_num: PropTypes.any
  }),
};
